import { Button } from '@aod/ui/components/ui/button';
import { useState } from 'react';
import { parseWatchTarget } from '../../spectate/watchLink';

const INPUT_CLASS =
  'min-h-11 rounded-md border border-amber-200/30 bg-black/40 px-4 py-3 text-amber-50 placeholder:text-amber-100/60 focus-visible:border-amber-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/50';

/** Open the read-only viewer on a running match, from its id or a watch link. */
export function WatchField({ onWatch }: { onWatch: (matchId: string) => void }) {
  const [input, setInput] = useState('');
  const id = parseWatchTarget(input);
  return (
    <div className="flex gap-2">
      <input
        className={`${INPUT_CLASS} min-w-0 flex-1`}
        placeholder="Match id or watch link"
        aria-label="Match to watch"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <Button
        type="button"
        variant="secondary"
        size="lg"
        data-testid="mp-watch"
        onClick={() => id && onWatch(id)}
        disabled={!id}
      >
        Watch
      </Button>
    </div>
  );
}
